import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=a639c390&scoped=true"
import script from "./QuickUser.vue?vue&type=script&lang=js"
export * from "./QuickUser.vue?vue&type=script&lang=js"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=a639c390&prod&lang=scss&scoped=true"
import style1 from "./QuickUser.vue?vue&type=style&index=1&id=a639c390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a639c390",
  null
  
)

export default component.exports